var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "c-outages-footer",
      class: { "c-outages-footer--list-view": _vm.outagePageView === "list" },
    },
    [
      _c(
        "div",
        {
          staticClass: "c-outages-footer__report",
          class: {
            "c-outages-footer__report--list-view":
              _vm.outagePageView === "list",
          },
        },
        [
          _c("div", { staticClass: "c-outages-footer__report-inner" }, [
            _c("img", {
              attrs: {
                src: "_resources/app/client/assets/icons/outages-map/alert-icon.svg",
              },
            }),
            _vm._v(" "),
            _c("h2", { staticClass: "c-outages-footer__report-title" }, [
              _vm._v("\n        No power and can't see your outage?\n      "),
            ]),
            _vm._v(" "),
            _vm.cmsContent.reportOutageLink
              ? _c(
                  "a",
                  {
                    staticClass: "c-outages-footer__report-link",
                    attrs: { href: _vm.cmsContent.reportOutageLink },
                  },
                  [
                    _c(
                      "button",
                      { staticClass: "c-outages-footer__report-button" },
                      [_vm._v(_vm._s(_vm.cmsContent.reportOutageText))]
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "c-outages-footer__panels",
          class: {
            "c-outages-footer__panels--list-view":
              _vm.outagePageView === "list",
          },
        },
        _vm._l(_vm.cmsContent.featuredImages, function (featuredImage) {
          return _c(
            "div",
            {
              key: featuredImage.SortOrder,
              staticClass: "c-outages-footer__panel",
              class: {
                "c-outages-footer__panel--list-view":
                  _vm.outagePageView === "list",
              },
            },
            [
              _c(
                "div",
                { staticClass: "c-outages-footer__panel-image-wrapper" },
                [
                  _c("img", {
                    staticClass: "c-outages-footer__panel-image",
                    attrs: { src: featuredImage.Image },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "c-outages-footer__panel-link",
                  attrs: {
                    href: featuredImage.Link,
                    alt: featuredImage.Description,
                  },
                },
                [_vm._v(_vm._s(featuredImage.LinkTitle))]
              ),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }